import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientDetailLayoutSkeleton } from '@/feature/hotline/client/detail/component/HotlineClientDetailLayout';
import { hotlineClientDetailViewStyle } from '@/feature/hotline/client/detail/index/page/style';
import { HotlineDescriptionListSkeleton } from '@/feature/hotline/component/HotlineDescriptionList';
/**
 * 匿名コンサルホットライン クライアント詳細 スケルトン画面
 */
export const HotlineClientDetailViewSkeleton = () => {
    const style = hotlineClientDetailViewStyle();
    return (_jsx(HotlineClientDetailLayoutSkeleton, Object.assign({ activeStepIndex: 0, classNames: { childrenWrap: style.base() } }, { children: _jsx(HotlineDescriptionListSkeleton, {}) })));
};
